import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  memo,
} from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "../styles/herobanner.css";
import { getHomepage } from "../services/home.service";

function HeroBanner() {
  const [slides, setSlides] = useState([]);
  const videoRefs = useRef([]);

  // API Fetch
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getHomepage();
        setSlides(data);
      } catch (error) {
        console.error("Error fetching homepage data:", error);
      }
    };

    fetchData();
  }, []);

  // Handle Slide Change
  const handleSlide = useCallback((swiper) => {
    // Sabhi videos reset
    videoRefs.current.forEach((video) => {
      if (video) {
        video.pause();
        video.currentTime = 0;
        video.onended = null;
      }
    });

    // Current active slide
    const activeIndex = swiper.realIndex;
    const activeVideo = videoRefs.current[activeIndex];

    if (activeVideo) {
      swiper.autoplay.stop();

      activeVideo.play().catch(() => {});

      activeVideo.onended = () => {
        swiper.slideNext();
        swiper.autoplay.start();
      };
    } else {
      swiper.autoplay.start();
    }
  }, []);

  return (
    <div className="slider-wrapper">
      <Swiper
        modules={[Navigation, Autoplay, Pagination]}
        loop={true}
        navigation={true}
        speed={200}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        pagination={{ clickable: true }}
        className="main-slider"
        onSwiper={handleSlide}
        onSlideChange={handleSlide}
      >
        {slides.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="slide-container">
              
              {/* Video */}
              {item.media_type === "video" && (
                <video
                  ref={(el) => {
                    videoRefs.current[index] = el;
                  }}
                  className="slide-video"
                  muted
                  playsInline
                  preload="metadata"
                >
                  <source
                    src={item.media.desktop}
                    type="video/mp4"
                  />
                </video>
              )}

              {/* Image */}
              {item.media_type === "image" && (
                <picture>
                  <source
                    media="(max-width: 768px)"
                    srcSet={item.media.mobile}
                  />

                  <img
                    src={item.media.desktop}
                    alt={`slide-${index}`}
                    className="main-image-slider"
                    loading="lazy"
                    decoding="async"
                  />
                </picture>
              )}

            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default memo(HeroBanner);